import { render } from "./ListUserAssists.vue?vue&type=template&id=998b52c4"
import script from "./ListUserAssists.vue?vue&type=script&lang=js"
export * from "./ListUserAssists.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__